import { Spin } from 'antd';
import React, { lazy, Suspense, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Navigate, Route, Routes } from 'react-router-dom';
import { returnErrorPage } from '../components/Fallbacks/ErrorScreenHandler';
import WebSocketComponent from '../pages/Upgradation/UpgradeForm/ws';
import lazyWithRetry from './lazyWithRetry';
import ClaimForm from '../pages/Dashboard/Claims/AddClaim/ClaimForm/ClaimForm';
import { BROKERSWITHINTEGRATION } from '../constants/config';
import PrivacyPolicyLayout from '../pages/PrivacyPolicy/Layout';
import PrivacyPolicy from '../pages/PrivacyPolicy/PrivacyPolicy';
import TermsAndConditions from '../pages/PrivacyPolicy/TermsAndConditions';
const ChooseEntity = lazyWithRetry(() => import('../pages/Dashboard/ChooseEntity/ChooseEntity'));
const EmployeeRequests = lazyWithRetry(() => import('../pages/Dashboard/Members/ManageRequests/EmployeeRequests'));
const Login = lazyWithRetry(() => import('../pages/Login/LoginScreen/Login'));
const CheckSSO = lazyWithRetry(() => import('../pages/Login/LoginScreen/CheckSSO'));
const IssuanceFailure = lazyWithRetry(() => import('../pages/Upgradation/UpgradeForm/IssuanceFailure'));
const Product = lazyWithRetry(() => import('../pages/Dashboard/Members/AddMember/ProductDetails/Product'));
const Bulk = lazyWithRetry(() => import('../pages/Dashboard/Members/BulkAddition/Bulk'));
const ReviewScreen = lazyWithRetry(() => import('../pages/Dashboard/Members/BulkAddition/ReviewScreen'));
const UploadScreen = lazyWithRetry(() => import('../pages/Dashboard/Members/BulkAddition/UploadScreen'));
const BulkDeletion = lazyWithRetry(() => import('../pages/Dashboard/Members/BulkDeletion/BulkDeletion'));
const SettingsLayout = lazyWithRetry(() => import('../pages/Dashboard/Settings/SettingsLayout'));
const AutomateHRMS = lazyWithRetry(() => import('../pages/Dashboard/Settings/HRMS/AutomateHRMS'));
const CongratulationsScreen = lazyWithRetry(() => import('../pages/Upgradation/UpgradeForm/CongratulationsScreen'));
const PaymentFailure = lazyWithRetry(() => import('../pages/Upgradation/UpgradeForm/PaymentFailure'));
const UpgradingScreen = lazyWithRetry(() => import('../pages/Upgradation/UpgradeForm/UpgradingScreen'));
const ClaimsDetails = lazyWithRetry(() => import('../pages/Dashboard/Claims/ClaimsDetails'));
const ProductsHRMS = lazyWithRetry(() => import('../pages/Dashboard/Members/HRMSAddition/ProductsHRMS'));
const HowToClaim = lazyWithRetry(() => import('../pages/Dashboard/Claims/AddClaim/HowToClaim'));
const Claims = lazyWithRetry(() => import('../pages/Dashboard/Claims/Claims'));
const ProfileSection = lazyWithRetry(() => import('../pages/Dashboard/Profile/ProfileSection'));
const ProfileLayout = lazy(() => import('../pages/Dashboard/Profile/ProfileLayout'));
const PagePolicies = lazy(() => import('../pages/Dashboard/PagePolicies/PagePolicies'));
const RequestOTPBPIDA = lazy(() => import('../pages/Login/OTPScreenBP/RequestOTPIDA'));
const RequestOTPBP = lazy(() => import('../pages/Login/OTPScreenBP/RequestOTP'));
const RequestOTPUPL = lazy(() => import('../pages/Login/OTPScreenBP/RequestOTPUPL'));
const OTPScreenBP = lazy(() => import('../pages/Login/OTPScreenBP/OTPScreen'));
const OTPScreenUPL = lazy(() => import('../pages/Login/OTPScreenBP/OTPScreenUPL'));
const OTPScreenBPIDA = lazy(() => import('../pages/Login/OTPScreenBP/OTPScreenIDA'));
const RequestAadharKYCOTP = lazy(() => import('../pages/Login/AadharKYC/RequestOTP'));
const SubmitAadharKYCOTP = lazy(() => import('../pages/Login/AadharKYC/OTPScreen'));
//retail
const AwaitingApproval = lazy(() => import('../pages/Dashboard/InvitedMember/AwaitingApproval'));
const InvitedMember = lazy(() => import('../pages/Dashboard/InvitedMember/InvitedMember'));
const ForgotPassword = lazy((): any => import('../pages/Login/ForgotPassword/ForgotPassword'));
const ClaimsLayout = lazy(() => import('../pages/Dashboard/Claims/ClaimsLayout'));
const AddClaim = lazy(() => import('../pages/Dashboard/Claims/AddClaim/AddClaim'));
const ClaimGuide = lazy(() => import('../pages/Dashboard/Claims/AddClaim/ClaimGuidePage'));
const MembersLayout = lazy(() => import('../pages/Dashboard/Members/MembersLayout'));
const MembersHRMS = lazy(() => import('../pages/Dashboard/Members/HRMSAddition/MembersHRMS'));
const ProductsLayout = lazy(() => import('../pages/Dashboard/Products/ProductsLayout'));
const LandingPage = lazy(() => import('../pages/Upgradation/LandingPage/LandingPage'));
const Base = lazy(() => import('../pages/Upgradation/UpgradeForm/Base'));
const Proposal = lazy(() => import('../pages/Upgradation/UpgradeForm/Proposal'));
const PostPayment = lazy(() => import('../pages/Upgradation/UpgradeForm/PostPayment'));
const PaymentInProgress = lazy(() => import('../pages/Upgradation/UpgradeForm/Payment/PaymentInProgress'));
const AddMember = lazy(() => import('../pages/Dashboard/Members/AddMember/AddMember'));
const SetPassword = lazy(() => import('../pages/Login/SetPassword/SetPassword'));
const ResetPassword = lazy(() => import('../pages/Login/ResetPassword/ResetPassword'));
const LandingLogin = lazy(() => import('../pages/Login/LandingLogin/LandingLogin'));
const OTPVerification = lazy(() => import('../pages/Login/OTPVerification/OTPVerification'));
const PasswordVerification = lazy(() => import('../pages/Login/PasswordVerification/PasswordVerification'));
const TripSafeLogin = lazy(() => import('../pages/Login/TripSafeLogin/TripSafeLogin'));
const MemberDetails = lazy(() => import('../pages/Dashboard/Members/AddMember/MemberDetails/MemberDetails'));
const InviteMemberDetails = lazy(() => import('../pages/Dashboard/Members/InviteMember/InviteMemberDetails'));
const InviteMemberProducts = lazy(() => import('../pages/Dashboard/Members/InviteMember/InviteMemberProducts'));
//retail
const RetailPostPayment = lazyWithRetry(() => import('../pages/Retail/PostPayment'));
const CreateOrderNRedirect = lazyWithRetry(() => import('../pages/Partner/CreateOrderNRedirect'));
const PartnerPostPayment = lazyWithRetry(() => import('../pages/Partner/PartnerPostPayment'));
const PlaceOrder = lazyWithRetry(() => import('../pages/Partner/PlaceOrder'));
const ORPPaymentRedirect = lazyWithRetry(() => import('../pages/ORP/PaymentRedirect'));

const ORPLanding = lazyWithRetry(() => import('../pages/ORP/Landing'));
const ORPOfferings = lazyWithRetry(() => import('../pages/ORP/Offerings'));
const ORPCheckout = lazyWithRetry(() => import('../pages/ORP/Checkout'));
const ORPPostPayment = lazyWithRetry(() => import('../pages/ORP/PostPayment'));
const AppRedirect = lazyWithRetry(() => import('../pages/AppRedirect/AppRedirect'));
const Hubble = lazyWithRetry(() => import('../pages/Hubble/Hubble'));
const Even = lazyWithRetry(() => import('../pages/Even/Even'));
const Explore = lazyWithRetry(() => import('../pages/Dashboard/Explore/Explore'));

const Router: React.FC = () => {
  const brokerName = useSelector((state: any) => state.theme.brokerName),
    isWellnessOnly = useSelector((state: any) => state.auth.is_wellness_only),
    { isLoggedIn, activeMode, status } = useSelector((state: any) => state.auth),
    isUHIActive = window.location.pathname.includes('upgrade-policy') ? true : false,
    isBimaPremium = window.location.href.includes('premiumbima') ? true : false,
    isKYC = window.location.href.includes('kyc') ? true : false,
    // isReady = () => {
    //   if (isUHIActive) return !isLoggedIn || (isLoggedIn && !!status);
    //   if (!isLoggedIn) return true;
    //   return !!(status && activeMode);
    // },
    // // Start from the current state so a remount with `status` already known doesn't flash the spinner.
    // [loading, setLoading] = useState(() => !isReady());
    [loading, setLoading] = useState(true);

  useEffect(() => {
    if (isUHIActive) {
      if (!isLoggedIn || (isLoggedIn && status)) {
        setLoading(false);
      }
      return;
    }

    if (!isLoggedIn) {
      setLoading(false);
      return;
    }

    if (isLoggedIn && status && activeMode) {
      setLoading(false);
    }
  }, [activeMode, status, isLoggedIn, isUHIActive]);

  if (loading) {
    return (
      <div className="loader-div">
        <div className="loader">
          <Spin />
        </div>
      </div>
    );
  }

  if (isWellnessOnly) {
    return <Suspense
      fallback={
        <div className="loader-div">
          <div className="loader">
            <Spin />
          </div>
        </div>
      }
    >
      <Routes>
        {!isLoggedIn && (
          <>
            <Route path="/" element={<Login />}>
              <Route path="" element={<CheckSSO type="email" />} />
              <Route path="login-with-email" element={<CheckSSO type="email" />} />
              <Route path="login-with-phone" element={<CheckSSO type="phone" />} />
            </Route>
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/request-password-reset" element={<ForgotPassword />} />
            {/* <Route path="/request-otp" element={<RequestOTP />} />
            <Route path="/login-with-otp" element={<OTPScreen />} /> */}
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}

        {status === 'INVITED' && (
          <>
            <Route path="/" element={<Navigate to="/invited-member" />} />
            <Route path="/invited-member/*" element={<InvitedMember />} />
            <Route path="/awaiting-approval" element={<AwaitingApproval />} />
          </>
        )}

        {isLoggedIn && <>
          <Route path="/" element={<Navigate to="/wellness" />} />
          <Route path="/wellness/:partner/*">
            <Route path="" element={<ORPLanding />} />
            <Route path="product/:productid" element={<ORPOfferings sourceType="product" />} />
            <Route path="offer/:offerid" element={<ORPOfferings sourceType="offer" />} />
            <Route path="checkout" element={<ORPCheckout />} />
            <Route path="post-payment" element={<ORPPostPayment />} />
          </Route>
          <Route path="/wellness/*">
            <Route path="" element={<ORPLanding />} />
            <Route path="product/:productid" element={<ORPOfferings sourceType="plan" />} />
            <Route path="offer/:offerid" element={<ORPOfferings sourceType="offer" />} />
            <Route path="checkout" element={<ORPCheckout />} />
            <Route path="post-payment" element={<ORPPostPayment />} />
          </Route>
          <Route path="/retail/*">
            <Route path="post-payment" element={<RetailPostPayment />} />
          </Route>
          <Route path="/redirect/wellness/partner/:partner/payment" element={<ORPPaymentRedirect />} />
          <Route path="/redirect/wellness/payment" element={<ORPPaymentRedirect />} />
          <Route path="*" element={<Navigate to="/wellness" />} />
        </>}
      </Routes>
    </Suspense>;
  }

  return (
    <Suspense
      fallback={
        <div className="loader-div">
          <div className="loader">
            <Spin />
          </div>
        </div>
      }
    >
      <Routes>
        <Route path="/upl/otp" element={<RequestOTPUPL />} />
        <Route path="/upl/verify-otp" element={<OTPScreenUPL />} />

        <Route path="/tripsafe-login" element={<TripSafeLogin />} />
        {isBimaPremium === true && (
          <>
            <Route path="/otp" element={<RequestOTPBP />} />
            <Route path="/ida/otp" element={<RequestOTPBPIDA />} />
            <Route path="/verify-otp" element={<OTPScreenBP />} />
            <Route path="/ida/verify-otp" element={<OTPScreenBPIDA />} />
            {/* <Route path="/*" element={<RequestOTPBP />} /> */}
            {/* <Route path="/" element={<RequestOTPBP />} /> */}
          </>
        )}
        {/* {activeMode === 'employee' && ( */}
        <>
          <Route path="/upgrade-policy/*">
            <Route path="page-policies" element={<PagePolicies />} />
            <Route path="*" element={<LandingPage />} />
            <Route path="select-members" element={<Base />} />
            <Route path="proposal" element={<Proposal />} />
            <Route path="payment-in-progress" element={<PaymentInProgress />} />
            <Route path="post-payment" element={<PostPayment />} />
            <Route path="pp1" element={<UpgradingScreen />} />
            <Route path="pp2" element={<CongratulationsScreen />} />
            <Route path="pp3" element={<PaymentFailure />} />
            <Route path="pp4" element={<IssuanceFailure />} />
          </Route>
        </>
        {/* )} */}

        {status === 'INACTIVE' && (
          <>
            {isLoggedIn && (
              <>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/home" element={<MembersLayout />} />
                <Route path="/claims" element={<Claims />}>
                  <Route path="" element={<ClaimsLayout />} />
                  <Route path=":id" element={<ClaimsDetails />} />
                  <Route path="how-to-claim/:id" element={<HowToClaim />} />
                  <Route path="add-claim">
                    <Route path="" element={<AddClaim />} />
                    <Route path=":id" element={<ClaimGuide />} />
                  </Route>
                </Route>
              </>
            )}
          </>
        )}

        {status === 'ACTIVE' && (
          <>
            {isLoggedIn && (
              <>
                <Route path="/page-policies" element={<PagePolicies />} />
                <Route path="/profile" element={<ProfileLayout />} />
                <Route path="/profile/my-account" element={<ProfileSection />} />
                {activeMode === 'employee' && (
                  <>
                    <Route path="/" element={<Navigate to="/home" />} />
                    <Route path="/home" element={<MembersLayout />} />
                    <Route path="/dashboard" element={<Navigate to="/home" />} />
                    <Route path="/gift-cards" element={<Hubble />} />
                    <Route path="/even/:feature" element={<Even />} />
                    <Route path="/explore" element={<Explore />} />
                    <Route path="/claims" element={<Claims />}>
                      <Route path="" element={<ClaimsLayout />} />
                      <Route path=":uuid" element={<ClaimsDetails />} />
                      <Route path="how-to-claim/:id" element={<HowToClaim />} />
                      <Route path="add-claim">
                        <Route path="" element={<AddClaim />} />
                        <Route path=":id" element={<ClaimGuide />} />
                        <Route path="claim-form" element={<ClaimForm />} />
                      </Route>
                    </Route>
                  </>
                )}

                {activeMode === 'employer' && (
                  <>
                    <Route path="/" element={<Navigate to="/dashboard" />} />
                    <Route path="/home" element={<Navigate to="/dashboard" />} />
                    <Route path="/dashboard" element={<ProductsLayout />} />
                    <Route path="/claims" element={<Claims />}>
                      <Route path="" element={<ClaimsLayout />} />
                      <Route path="view-claim/:uuid" element={<ClaimsDetails />} />
                    </Route>
                    <Route path="/members/*" element={<Claims />}>
                      <Route path="" element={<MembersLayout />} />
                      <Route path="hrms/*">
                        <Route path="" element={<MembersHRMS />} />
                        <Route path="products" element={<ProductsHRMS />} />
                      </Route>
                      <Route path="invite-member/*" element={<Bulk intent="INVITE" />}>
                        <Route path="" element={<InviteMemberDetails />} />
                        {/* <Route path=":memberid" element={<InviteMemberDetails />} /> */}
                        <Route path="product-details" element={<InviteMemberProducts />} />
                        {/* <Route path="product-details" element={<InviteMemberProducts />} /> */}
                        <Route path="bulk/*">
                          <Route path="" element={<UploadScreen intent="INVITED" />} />
                          <Route path="review" element={<ReviewScreen intent="INVITED" />} />
                        </Route>
                      </Route>
                      <Route path="member-requests" element={<EmployeeRequests />} />
                      <Route path="add-member/*" element={<AddMember />}>
                        <Route path="" element={<MemberDetails />} />
                        <Route path=":memberid" element={<MemberDetails />} />
                        <Route path=":memberid/product-details" element={<Product />} />
                        <Route path="product-details" element={<Product />} />
                      </Route>
                      <Route path="add-bulk/*" element={<Bulk intent="Add" />}>
                        <Route path="" element={<UploadScreen intent="ADDITION" />} />
                        <Route path="review" element={<ReviewScreen intent="ADDITION" />} />
                      </Route>
                      <Route path="delete-bulk/*" element={<Bulk intent="Delete" />}>
                        <Route path="" element={<BulkDeletion />} />
                      </Route>
                    </Route>
                    {(BROKERSWITHINTEGRATION?.includes(brokerName?.toLowerCase()) ||
                      brokerName?.toLowerCase()?.includes('demo')) && (
                        <>
                          <Route path="/integrations" element={<SettingsLayout />} />
                          <Route path="/integrations/automate" element={<AutomateHRMS />} />
                        </>
                      )}
                  </>
                )}
              </>
            )}
          </>
        )}
        {!isLoggedIn && (
          <>
            <Route path="/" element={<LandingLogin />} />
            <Route path="/otp-verification" element={<OTPVerification />} />
            <Route path="/password-verification" element={<PasswordVerification />} />
            <Route path="/old-login" element={<Login />}>
              <Route path="" element={<CheckSSO type="email" />} />
              <Route path="login-with-email" element={<CheckSSO type="email" />} />
              <Route path="login-with-phone" element={<CheckSSO type="phone" />} />
            </Route>
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/set-password" element={<SetPassword />} />
            <Route path="/request-password-reset" element={<ForgotPassword />} />
            <Route path="*" element={<Navigate to="/" />} />
            <Route path="/aadhar-kyc" element={<RequestAadharKYCOTP />} />
            <Route path="/aadhar-kyc/otp" element={<SubmitAadharKYCOTP />} />
          </>
        )}

        {status === 'INVITED' && (
          <>
            <Route path="/" element={<Navigate to="/invited-member" />} />
            <Route path="/invited-member/*" element={<InvitedMember />} />
            <Route path="/awaiting-approval" element={<AwaitingApproval />} />
          </>
        )}

        {(status === 'PENDING' || status === 'ADDITION_IN_PROCESS') && (
          <>
            {/* <Route path="/" element={<Navigate to="/invited-member" />} />
            <Route path="/invited-member/*" element={<InvitedMember />} /> */}

            <Route path="/" element={<Navigate to="/awaiting-approval" />} />
            <Route path="/awaiting-approval" element={<AwaitingApproval />} />
          </>
        )}
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/set-password" element={<SetPassword />} />

        <Route path="/403" element={returnErrorPage(403)} />
        <Route path="/404" element={returnErrorPage(404)} />
        <Route path="/500" element={returnErrorPage(500)} />
        <Route path="/503" element={returnErrorPage(503)} />
        <Route path="*" element={<Navigate to="/" />} />

        {/* retail */}

        {/* Retail to be deprecated. */}
        <Route path="/retail-partner/:partner/*">
          {/* <Route path="" element={<RetailLanding />} />
          <Route path="product/:productid" element={<RetailOfferings />} />
          <Route path="offer/:offerid" element={<RetailOfferings />} />
          <Route path="checkout" element={<RetailCheckout />} /> */}
          <Route path="post-payment" element={<RetailPostPayment />} />
        </Route>
        <Route path="ws" element={<WebSocketComponent />} />

        <Route path="/retail/*">
          {/* <Route path="" element={<RetailLanding />} />
          <Route path="product/:productid" element={<RetailOfferings />} />
          <Route path="offer/:offerid" element={<RetailOfferings />} />
          <Route path="checkout" element={<RetailCheckout />} /> */}
          <Route path="post-payment" element={<RetailPostPayment />} />
        </Route>

        <Route path="/partner/:partner/create-order" element={<CreateOrderNRedirect />} />
        <Route path="/partner/:partner/post-payment" element={<PartnerPostPayment />} />
        <Route path="/place-order" element={<PlaceOrder />} />

        {/* ORP */}
        <Route path="/wellness/:partner/*">
          <Route path="" element={<ORPLanding />} />
          <Route path="product/:productid" element={<ORPOfferings />} />
          <Route path="offer/:offerid" element={<ORPOfferings />} />
          <Route path="checkout" element={<ORPCheckout />} />
          <Route path="post-payment" element={<ORPPostPayment />} />
        </Route>
        <Route path="/wellness/*">
          <Route path="" element={<ORPLanding />} />
          <Route path="product/:productid" element={<ORPOfferings />} />
          <Route path="offer/:offerid" element={<ORPOfferings />} />
          <Route path="checkout" element={<ORPCheckout />} />
          <Route path="post-payment" element={<ORPPostPayment />} />
        </Route>
        <Route path="/redirect/wellness/partner/:partner/payment" element={<ORPPaymentRedirect />} />
        <Route path="/redirect/wellness/payment" element={<ORPPaymentRedirect />} />
        <Route path="/privacy-policy/*" element={<PrivacyPolicyLayout />}></Route>
        <Route path="/terms-and-conditions/*" element={<PrivacyPolicyLayout />}></Route>
        <Route path="/app-redirect" element={<AppRedirect />} />
        <Route path="/app-review" element={<AppRedirect reviewIntent />} />
      </Routes>
    </Suspense>
  );
};

export default Router;
